import mime from 'mime'

export const base64FromBlob = async (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(btoa(reader.result))
        reader.readAsBinaryString(blob)
    })
}

export const chooseFiles = async ({
    types = [
        {
            description: '*.*',
            accept: {}
        },
    ],

    ...options
} = {}) => {
    try {
        const fileHandles = await window.showOpenFilePicker({
            types,
            ...options,
        })

        return await Promise.all(
            fileHandles.map(async fileHandle => {
                const f = await fileHandle.getFile()

                if (f.type) {
                    return f
                }
                else {
                    const type = mime.getType(f.name) || 'text/plain'
                    return new File([f], f.name, {type})
                }
            })
        )
    }
    catch (err) {
        if ('AbortError' === err.name) {
            return []
        }
        else {
            throw err
        }
    }
}

export const dataUrlFromBlob = async (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
    })
}

chooseFiles.image = (options) => {
    return chooseFiles({
        types: [
            {
                description: 'Images',

                accept: {
                    'image/*': [
                        '.png',
                        '.gif',
                        '.jpeg',
                        '.jpg',
                    ]
                }
            },
        ],

        ...options,
    })
}

export const downloadFile = (data, fileName) => {
    const url = URL.createObjectURL(data)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
}

export const fileFromClipboard = async (type, filename) => {
    const items = await navigator.clipboard.read()

    for (const item of items) {
        if (item.types.includes(type)) {
            const blob = await item.getType(type)
            return new File([blob], filename, {type})
        }
    }

    return null
}

export const writeFileToDisk = async (data, options) => {
    try {
        const fileHandle = await window.showSaveFilePicker(options)
        const ws = await fileHandle.createWritable()
        await ws.write(data)
        await ws.close()
    }
    catch (err) {
        if ('SecurityError' === err.name) {
            downloadFile(data, options.suggestedName)
        }
        else if ('AbortError' !== err.name) {
            throw err
        }
    }
}

export const getExt = (fileName) => {
    const ext = fileName.replace(/^.*\.([^.]*)$/, '$1')
    return ext === fileName ? '' : ext
}

export const humanReadableSize = bytes => {
    const units = ['', 'K', 'M', 'G', 'T', 'P']
    let b = 1

    for (const u of units) {
        if (bytes < b * 1024) {
            return `${Math.round(bytes / b * 10) / 10}${u}B`
        }

        b *= 1024
    }
}
